import { render, staticRenderFns } from "./DRSTBoxFilterable.vue?vue&type=template&id=7425aa90&"
import script from "./DRSTBoxFilterable.vue?vue&type=script&lang=ts&"
export * from "./DRSTBoxFilterable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7425aa90')) {
      api.createRecord('7425aa90', component.options)
    } else {
      api.reload('7425aa90', component.options)
    }
    module.hot.accept("./DRSTBoxFilterable.vue?vue&type=template&id=7425aa90&", function () {
      api.rerender('7425aa90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/DRSTBoxFilterable.vue"
export default component.exports